import React from 'react';

import { ProductImage } from '@Calix-Commerce/design-system/components';
import placeholderImage from '@Calix-Commerce/design-system/assets/img/no-image.jpg';

import {
  ProductDetailsWrapper,
  ProductImageWrapper,
  ProductWrapper,
  PartNumber,
  PartDescription,
  StatusMessage,
} from './styledComponents';

export const Product = ({
  getImages,
  partNumber,
  partName,
  description,
  statusMessage,
  statusType = 'danger',
}) => {
  return (
    <ProductWrapper>
      <ProductImageWrapper>
        <ProductImageWrapper>
          <ProductImage
            alt={partName}
            src={getImages.length ? getImages[0].imageAbsoluteUrl : placeholderImage}
          />
        </ProductImageWrapper>
      </ProductImageWrapper>
      <ProductDetailsWrapper>
        <PartNumber>{partNumber}</PartNumber>
        <PartDescription>{description || partName}</PartDescription>
        {statusMessage ? (
          <StatusMessage className={`status-${statusType}`}>
            <li>{statusMessage}</li>
          </StatusMessage>
        ) : null}
      </ProductDetailsWrapper>
    </ProductWrapper>
  );
};

export default Product;
